import type {
  LinkStyles,
  PrimaryButtonsStyles,
  SecondaryButtonsStyles
} from '~/types/branding/button-items';

export const useButtonItemsStore = defineStore('button-items', {
  state: () => ({
    prodPrimaryButtonStyles: {
      backgroundColor: '#0E75C8',
      backgroundColorHover: '#094E85',
      textColor: '#FFFFFF',
      textColorHover: '#FFFFFF'
    } as PrimaryButtonsStyles,
    prodSecondaryButtonStyles: {
      backgroundColor: '#FFFFFF',
      backgroundColorHover: '#F5FAFE',
      borderColor: '#0E75C8',
      borderColorHover: '#0E75C8',
      textColor: '#0E75C8',
      textColorHover: '#0E75C8'
    } as SecondaryButtonsStyles,
    prodLinkStyles: { textColor: '#0E75C8', textColorHover: '#094E85' } as LinkStyles,
    primaryButtonStyles: {} as PrimaryButtonsStyles,
    secondaryButtonStyles: {} as SecondaryButtonsStyles,
    linkStyles: {} as LinkStyles,
    buttonsBorderRadius: 'rounded' as string,
    buttonLinkItemsState: 'default' as string
  })
});
